//基本盘
import Vue from 'vue'
//基本样式
import './portal/basic.scss'
import index from './portal/Main.vue'
import "./plugins/lazyload"

import 'vant/lib/index.css'
import { Swipe, SwipeItem, Popup, Toast, Icon, Image as VanImage, Button } from 'vant';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(Toast );
Vue.use(Icon );
Vue.use(VanImage)
Vue.use(Button)

// 全局注册神策埋点
import sensors from './utils/sensorsdata'
Vue.prototype.$sensors = sensors

// 复制粘贴插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 判断客户端
import { UA } from './libaray/js/ua'
Vue.prototype.$UA = UA

new Vue({
    render: h => h(index)
}).$mount('#LandingPage');


